import { CoverType } from 'scenes/common/types';
import { WireCoverageRefId, WireCoverType } from '../types';

export const wireCoverageId: {
  [key in WireCoverType]: string;
} = {
  [WireCoverType.Comprehensive]: WireCoverageRefId.COMP,
  [WireCoverType.ComprehensivePlus]: WireCoverageRefId.COMPG,
  [WireCoverType.ThirdPartyFireAndTheft]: WireCoverageRefId.TPFT,
  [WireCoverType.ThirdPartyPropertyDamage]: WireCoverageRefId.TPPD,
  [WireCoverType.Building]: WireCoverageRefId.Home,
  [WireCoverType.BuildingAndContents]: WireCoverageRefId.HomenCon,
  [WireCoverType.Contents]: WireCoverageRefId.Contents,
  [WireCoverType.Unspecified]: '',
};

export const toWireCoverType = (coverType: CoverType): WireCoverType => {
  switch (coverType) {
    case CoverType.Building:
      return WireCoverType.Building;
    case CoverType.BuildingAndContents:
      return WireCoverType.BuildingAndContents;
    case CoverType.Contents:
      return WireCoverType.Contents;
    default:
      return WireCoverType.Unspecified;
  }
};

export const toCoverType = (coverType: WireCoverType): CoverType => {
  switch (coverType) {
    case WireCoverType.Building:
      return CoverType.Building;
    case WireCoverType.BuildingAndContents:
      return CoverType.BuildingAndContents;
    case WireCoverType.Contents:
      return CoverType.Contents;
    default:
      return CoverType.Unspecified;
  }
};
